import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { views } from "../services/api";
import { toast } from "../components/Toast";
import {
  BackIcon,
  PlusIcon,
  GridViewIcon,
  TrashIcon,
  HomeIcon,
  CameraIcon,
  UserIcon,
} from "../components/Icons";

function CustomViews() {
  const navigate = useNavigate();
  const [viewList, setViewList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadViews();
  }, []);

  const loadViews = async () => {
    try {
      const { data } = await views.list();
      setViewList(data);
    } catch (err) {
      console.error("Failed to load views:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Delete "${name}"?`)) return;
    try {
      await views.delete(id);
      loadViews();
    } catch (err) {
      console.error("Failed to delete view:", err);
      toast.error("Failed to delete view");
    }
  };

  return (
    <div style={{ minHeight: "100vh", paddingBottom: "80px" }}>
      <div className="header">
        <div className="header-content">
          <button
            onClick={() => navigate("/")}
            className="btn btn-ghost btn-icon"
          >
            <BackIcon size={20} />
          </button>
          <div className="header-text">
            <h1 className="header-title">Custom Views</h1>
            <p className="header-subtitle">
              Visual grid layouts for your storage
            </p>
          </div>
          <div className="header-actions-right">
            <button
              onClick={() => navigate("/views/create")}
              className="btn btn-ghost btn-icon"
            >
              <PlusIcon size={20} />
            </button>
          </div>
        </div>
      </div>

      <div className="container">
        {loading ? (
          <div className="text-center">
            <div className="spinner"></div>
          </div>
        ) : viewList.length === 0 ? (
          <div
            className="card text-center"
            style={{ padding: "var(--spacing-2xl)" }}
          >
            <div
              style={{
                marginBottom: "var(--spacing-lg)",
                color: "var(--text-muted)",
              }}
            >
              <GridViewIcon size={64} />
            </div>
            <h3 style={{ marginBottom: "var(--spacing-sm)" }}>
              No custom views
            </h3>
            <p
              className="text-muted"
              style={{ marginBottom: "var(--spacing-lg)" }}
            >
              Create a visual grid layout for your shelves and storage
            </p>
            <button
              onClick={() => navigate("/views/create")}
              className="btn btn-primary"
            >
              Create View
            </button>
          </div>
        ) : (
          <div className="grid">
            {viewList.map((view) => (
              <div
                key={view.id}
                className="card"
                style={{ padding: "var(--spacing-md)" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "var(--spacing-md)",
                  }}
                >
                  <div
                    onClick={() => navigate(`/views/${view.id}`)}
                    style={{ flex: 1, cursor: "pointer" }}
                  >
                    <div style={{ fontWeight: "600", marginBottom: "0.25rem" }}>
                      {view.name}
                    </div>
                    <div
                      className="text-muted"
                      style={{ fontSize: "0.875rem" }}
                    >
                      {view.config.cols}x{view.config.rows} grid
                      {view.parent_name && ` • ${view.parent_name}`}
                    </div>
                  </div>
                  <button
                    onClick={() => handleDelete(view.id, view.name)}
                    className="btn btn-ghost btn-icon btn-sm"
                    title="Delete"
                  >
                    <TrashIcon size={18} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default CustomViews;
